import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { Inputs } from 'modules/inputs';
import { OrderModel } from 'models/generated/Entities.GormCrm.Order';
import { Layout } from 'modules/layout';
import { SalesService } from 'services/sales.service';
import { TranslatePipe } from 'pipes/translate.pipe';
import { InputType } from 'enums/InputType';
import { ReasonType } from 'enums/ReasonType';
import { ReasonSelectComponent } from 'components/input/reason-select/reason-select.component';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';

@Component({
	selector: 'edit-order-externals',
	templateUrl: 'edit-order-externals.component.html',
	providers: [FormValidationService],
	imports: [Layout, Inputs, TranslatePipe, ReasonSelectComponent]
})
export class EditOrderExternalsComponent implements AfterViewInit {

	@ViewChild('reasons') reasonsSelect?: ReasonSelectComponent;
	@Output() updatedExternals = new EventEmitter<void>();
	public inputType = InputType;
	public reasonType = ReasonType;
	public annualValueForRenewal?: number;
	public remainingAmount?: number;
	public discountAmount?: number;
	public selectedDiscountReasonId?: string;

	private _order!: OrderModel;
	@Input()
	set order(order: OrderModel) {
		this._order = order;
		this.annualValueForRenewal = order.externalAnnualValueForRenewal;
		this.remainingAmount = order.externalRemainingAmount;
		this.selectedDiscountReasonId = order.discountReasonId;
		let discount = this.salesService.getOrderLinesDiscountSum(order.orderLines);
		this.discountAmount = discount != 0 ? discount : undefined;
	}
	get order() { return this._order }

	constructor(private navigationService: NavigationService, private salesService: SalesService) { }

	ngAfterViewInit() {
		this.setDefaultReason();
		this.reasonsSelect?.reasonsLoaded.subscribe(_ => {
			this.setDefaultReason();
		});
	}

	private setDefaultReason() {
		if (this.reasonsSelect && this.reasonsSelect.reasons.length == 1) this.selectedDiscountReasonId = this.reasonsSelect.reasons[0].id;
	}

	async save() {
		if (!this.order?.id) return;

		await this.salesService.updateDiscount(this.order.id, this.discountAmount, this.selectedDiscountReasonId);
		await this.salesService.updateExternals(this.order.id, this.remainingAmount, this.annualValueForRenewal);
		this.updatedExternals.emit();
		this.navigationService.closeView(this);
	}
}
